export enum INPUT_VALID_STATE {
    NO = 'no',
    UNCERTAIN = 'uncertain',
}
